import React from 'react';
import { FiAlertTriangle, FiX } from 'react-icons/fi';

// Confirmation modal — replaces the previous gray-800/pink-gradient
// look with the dashboard's surface tokens (card-chrome panel,
// btn-secondary for cancel, flat red for destructive confirm) so it
// reads as part of the same UI as the cards behind it.
//
// `zIndexClass` lets a caller push the modal above another stacked
// surface (the Send Commands modal sits at z-50, so its child confirm
// passes z-[60]).
const Modal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  zIndexClass = 'z-50',
}) => {
  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 ${zIndexClass}`}
      onClick={onClose}
    >
      <div
        className="card-chrome w-full max-w-md shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-3 mb-3">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-lg flex items-center justify-center bg-red-500/15 text-red-400 shrink-0">
              <FiAlertTriangle />
            </div>
            <h3 className="text-lg font-semibold text-white">{title}</h3>
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-300 transition-colors"
            aria-label="Close"
          >
            <FiX size={20} />
          </button>
        </div>

        <p className="text-sm text-gray-400 mb-5 leading-relaxed">{message}</p>

        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="btn-secondary">
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg text-sm font-medium bg-red-500 text-white hover:bg-red-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
